import { FC } from 'react';

import { CampaignDetail, SenderIdInventory } from '@/apis/core';
import { humanize } from '@/utils/string';

import DetailField from './DetailField';
import Section from './Section';
import SectionGrid from './SectionGrid';
import { SENDER_ID_TYPE_LABEL_MAP } from '../../constants';

interface SenderIdPreferenceSectionProps {
  campaign: CampaignDetail;
  senderIdData?: SenderIdInventory[];
}

const SenderIdPreferenceSection: FC<SenderIdPreferenceSectionProps> = ({
  campaign,
  senderIdData,
}) => {
  const firstSenderId = senderIdData?.[0];
  const routingMode = firstSenderId?.routingMode || campaign?.routingMode;
  const senderIdType = firstSenderId?.senderIdType || campaign?.senderIdType;

  return (
    <Section title="Sender ID Preference">
      <SectionGrid>
        <DetailField label="Routing Mode" data-testid="routingMode">
          {humanize(routingMode)}
        </DetailField>

        <DetailField label="Sender ID Type" data-testid="senderIdType">
          {senderIdType
            ? SENDER_ID_TYPE_LABEL_MAP[senderIdType] || senderIdType
            : 'N/A'}
        </DetailField>

        <DetailField
          label="Off-net Outbound Traffic Termination"
          data-testid="offNetOutboundTerminationSupported"
        >
          {campaign?.offNetOutboundTerminationSupported === true ? 'Yes' : 'No'}
        </DetailField>

        <DetailField
          label="Intl Inbound Termination for A2P SMS"
          data-testid="intlInboundTerminationSupported"
        >
          {campaign?.intlInboundTerminationSupported === true ? 'Yes' : 'No'}
        </DetailField>

        <DetailField
          label="Intl Outbound Termination for A2P SMS"
          data-testid="intlOutboundTerminationSupported"
        >
          {campaign?.intlOutboundTerminationSupported === true ? 'Yes' : 'No'}
        </DetailField>

        <DetailField
          label="On-net Inbound Traffic Termination"
          data-testid="onNetInboundTerminationSupported"
        >
          {campaign?.onNetInboundTerminationSupported === true ? 'Yes' : 'No'}
        </DetailField>

        <DetailField
          label="Off-net Inbound Traffic Termination"
          data-testid="offNetInboundTerminationSupported"
        >
          {!!campaign?.offNetInboundTerminationSupported === true
            ? 'Yes'
            : 'No'}
        </DetailField>
      </SectionGrid>
    </Section>
  );
};

export default SenderIdPreferenceSection;
